import DropdownTemplateView from '../../../../DropdownTemplateView'
import SimpleMenu, { Option } from '../../../../components/SimpleMenu'
import messageResource from '../../../../messageResource'
import $ from 'jquery'
import ClassicBridge from '../../../../next/ClassicBridge'

export default class WorkingDayEditor extends DropdownTemplateView {
    constructor({
        leaveBlackoutEnabled,
        addCorporateCallback = () => {},
        deleteCorporateCallback = () => {},
        addLeaveBlackoutCallback = () => {},
        deleteLeaevBlackoutCallback = () => {},
        openDeleteNonApprovedLeaveRequestsConfirmationCallback = () => {}
    } = {}) {
        super()

        this.callbacks = {
            addCorporateCallback,
            deleteCorporateCallback,
            addLeaveBlackoutCallback,
            deleteLeaevBlackoutCallback,
            openDeleteNonApprovedLeaveRequestsConfirmationCallback
        }

        this.state = {
            date: null,
            isLeaveBlackout: false,
        }

        this._leaveBlackoutEnabled = leaveBlackoutEnabled

        this.onStatePropertyChanged('isLeaveBlackout', (isLeaveBlackout) => {
            if (this._leaveBlackoutEnabled) {
                this.$markAsLeaveBlackoutButton.setState({
                    title: messageResource.getMessage(isLeaveBlackout ? 'work_schedule.remove_leave_blackout' : 'work_schedule.set_leave_blackout'),
                })
            }
        })
    }

    templateHtml() {
        return "<div class='regularNonworkingDayEditorContainer' />"
    }

    afterRender() {
        this.simpleMenu = new SimpleMenu().init(this.$el)

        if (this._leaveBlackoutEnabled) {
            this.$markAsLeaveBlackoutButton = new Option({
                onSelected: () => {
                    if (this.state.isLeaveBlackout) {
                        this.callbacks.deleteLeaevBlackoutCallback(this.state.date)
                        this.hide()
                    } else {
                        this.$markAsLeaveBlackoutButton.setState({ isLoading: true })
                    ClassicBridge
                        .getNonApprovedLeaveRequestsForDay(this.state.date)
                        .then((nonApprovedLeaveRequestsCount) => {
                            if (nonApprovedLeaveRequestsCount)
                                this.callbacks.openDeleteNonApprovedLeaveRequestsConfirmationCallback(this.$elementShowAt, this.state.date, nonApprovedLeaveRequestsCount)
                            else
                                this.callbacks.addLeaveBlackoutCallback(this.state.date)
                        })
                        .finally(() => {
                            this.$markAsLeaveBlackoutButton.setState({ isLoading: false })
                            this.hide()
                        })
                    }
                }
            }).init(this.simpleMenu.$el)
        }

        this.$markAsHolidayButton = new Option({
            onSelected: () => {
                this.callbacks.addCorporateCallback(this.state.date, this.state.isLeaveBlackout)
                this.hide()
            }
        }).init(this.simpleMenu.$el)
        this.$markAsHolidayButton.setState({
            title: messageResource.getMessage('work_schedule.mark_as_holiday'),
        })

        this.renderInitialState()
    }

    setOnHideCallback(callback) {
        this.onHideCallback = callback
    }

    setOnShowCallback(callback) {
        this.onShowCallback = callback
    }

    onHide() {
        super.onHide()
        this.onHideCallback()
    }

    onShow() {
        super.onShow()
        this.onShowCallback()
    }

    mouseDownTargetElement() {
        return $(document)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/WorkingDayEditor.js